import React, { ReactNode } from "react";
import classnames from "classnames";

import styles from "../CollapsableCard.module.scss";

interface Props {
  title?: string;
  rightTitle?: string;
  opened?: boolean;
  children?: ReactNode;
  className?: string;
}

const Body = ({
  opened,
  title,
  rightTitle,
  children,
  className,
}: Props): React.ReactElement => {
  return (
    <div
      className={classnames(styles.cardBody, className, {
        [styles.hidden]: !opened,
      })}
    >
      {(title || rightTitle) && (
        <div className={styles.cardBodyHeader}>
          {title && <span className={styles.cardBodyTitle}>{title}</span>}
          {rightTitle && (
            <span className={styles.cardBodyTitle}>{rightTitle}</span>
          )}
        </div>
      )}
      {children}
    </div>
  );
};

export default Body;
